/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { AssetBodyDtoType } from './assetBodyDtoType';

export interface AssetBodyDto {
  /** Asset name */
  name: string;
  /** Asset file name */
  fileName: string;
  /** Asset type. By default: `supportingDocument` */
  type?: AssetBodyDtoType;
}
